<template>
    <div class="permission-container">
        <el-empty
            :description="$t(text)"
            :image="permissionBgImage"
        />
    </div>
</template>

<script lang="ts" setup>
import permissionBgImage from '@/assets/images/pemission-mask.png';
import {useI18n} from 'vue-i18n';
const i18n = useI18n();
const props = defineProps({
    text: {
        type: String,
        default: 'msg.permissionText'
    }
});
</script>

<style lang="scss" scoped>
.permission-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background-color: #fff;
}
</style>
